/**
 * QUOTES STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import { getQuotes, getQuote, printQuote, createQuotes, updateQuotes, deleteQuotes, createOrderFromQuote } from "Modules/sales/quotes/config/api.quotes";

const state = {
    page: {},
    form: {},
    quotes: [],
    selectedQuote: {
        quote_id: null,
        company_id: "",
        quote_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        quote_details: [],
    },
    quotes_filter: {
        search: "",
        status_id: "",
        page_size: 2,
        page_num: 1,
    },
    rules_quotes: {
        quote_id: {
            name: "quote_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        status_id: {
            name: "status_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        rfq_id: {
            name: "rfq_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        company_id: {
            name: "company_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        billing_address_id: {
            name: "billing_address_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        bill_location_label: {
            name: "bill_location_label",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        bill_address1: {
            name: "bill_address1",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        bill_address2: {
            name: "bill_address2",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        bill_city: {
            name: "bill_city",
            rules: "trim|max_length[100]",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        bill_state: {
            name: "bill_state",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        bill_zip_code: {
            name: "bill_zip_code",
            rules: "trim|max_length[5]",
            max_len: "5",
            min_len: "",
            default_value: "",
        },
        bill_zip_code_ext: {
            name: "bill_zip_code_ext",
            rules: "trim|max_length[4]",
            max_len: "4",
            min_len: "",
            default_value: "",
        },
        bill_country_iso_3: {
            name: "bill_country_iso_3",
            rules: "trim|max_length[3]",
            max_len: "3",
            min_len: "",
            default_value: "",
        },
        shipping_address_id: {
            name: "shipping_address_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        ship_location_label: {
            name: "ship_location_label",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        ship_address1: {
            name: "ship_address1",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        ship_address2: {
            name: "ship_address2",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        ship_city: {
            name: "ship_city",
            rules: "trim|max_length[100]",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        ship_state: {
            name: "ship_state",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        ship_zip_code: {
            name: "ship_zip_code",
            rules: "trim|max_length[5]",
            max_len: "5",
            min_len: "",
            default_value: "",
        },
        ship_zip_code_ext: {
            name: "ship_zip_code_ext",
            rules: "trim|max_length[4]",
            max_len: "4",
            min_len: "",
            default_value: "",
        },
        ship_country_iso_3: {
            name: "ship_country_iso_3",
            rules: "trim|max_length[3]",
            max_len: "3",
            min_len: "",
            default_value: "",
        },
        quoted_by_id: {
            name: "quoted_by_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        quote_date: {
            name: "quote_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        expire_date: {
            name: "expire_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        currency_id: {
            name: "currency_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        exchange_rate: {
            name: "exchange_rate",
            rules: "trim|max_length[19]|decimal|required",
            max_len: "19",
            min_len: "",
            default_value: "",
        },
        shipping_carrier_id: {
            name: "shipping_carrier_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        freight_term_id: {
            name: "freight_term_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        discount: {
            name: "discount",
            rules: "trim|max_length[13]|decimal|unsigned",
            max_len: "12",
            min_len: "",
            default_value: "0.000",
        },
        customer_po: {
            name: "customer_po",
            rules: "trim|max_length[36]",
            max_len: "36",
            min_len: "",
            default_value: "",
        },
        comments: {
            name: "comments",
            rules: "trim",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
        discount: {
            name: "discount",
            rules: "trim|max_length[10]|decimal",
            max_len: "10",
            min_len: "",
            default_value: "",
        },
        discount_type: {
            name: "discount_type",
            rules: "trim|max_length[1]",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        expedite_fee: {
            name: "expedite_fee",
            rules: "trim|max_length[13]|decimal|unsigned",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        handling_charge: {
            name: "handling_charge",
            rules: "trim|max_length[13]|decimal|unsigned",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        freight: {
            name: "freight",
            rules: "trim|max_length[13]|decimal|unsigned",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        customs: {
            name: "discount",
            rules: "trim|max_length[13]|decimal|unsigned",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        department_id: {
            name: "department_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        payment_term_id: {
            name: "payment_term_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        project_id: {
            name: "project_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        quote_details: {
            part_id: {
                name: "part_id",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            quantity: {
                name: "quantity",
                rules: "trim|max_length[11]|integer|required",
                max_len: "11",
                min_len: "",
                default_value: "",
            },
            line_discount_amount: {
                name: "line_discount_amount",
                rules: "trim|max_length[10]|decimal",
                max_len: "10",
                min_len: "",
                default_value: "",
            },
            line_discount_percentage: {
                name: "line_discount_percentage",
                rules: "trim|max_length[10]|decimal",
                max_len: "10",
                min_len: "",
                default_value: "",
            },
            line_discount_type: {
                name: "line_discount_type",
                rules: "trim|max_length[1]",
                max_len: "1",
                min_len: "",
                default_value: "",
            },
            cost_price: {
                name: "cost_price",
                rules: "trim|max_length[13]|decimal",
                max_len: "12",
                min_len: "",
                default_value: "",
            },
            unit_price: {
                name: "unit_price",
                rules: "trim|max_length[13]|decimal",
                max_len: "12",
                min_len: "",
                default_value: "",
            },
            sales_unit: {
                name: "sales_unit",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            lead_time: {
                name: "lead_time",
                rules: "trim|max_length[3]|integer",
                max_len: "3",
                min_len: "",
                default_value: "",
            },
        },
    },
};

// getters
const getters = {
    quotes: (state) => {
        return state.quotes;
    },
};

// actions
const actions = {
    async fetchQuotes({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            body = payload.body ? payload.body : "";

            const response = await getQuotes({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("setPageQuotes", response.data.page);
                }

                commit("setQuotes", response.data.quotes);

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchQuote({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getQuote(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("setSelectedQuote", response.data.quote);
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printQuote({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printQuote(payload.id, payload.view_as);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveQuote({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["quote_id"] === "undefined" || body["quote_id"] == null || body["quote_id"] == "") {
                delete body["quote_id"];
                response = await createQuotes({ body: body, headers: config.headers });
            } else {
                let quote_id = body["quote_id"];
                delete body["quote_id"];
                response = await updateQuotes({ body: body, headers: config.headers }, quote_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async convertQuoteToOrder({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            let quote_id = body["quote_id"];
            delete body["quote_id"];
            response = await createOrderFromQuote({ body: body, headers: config.headers }, quote_id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteQuote({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteQuotes(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    setPageQuotes(state, page) {
        state.page = page;
    },
    setQuotes(state, quotes) {
        state.quotes = quotes;
    },
    setSelectedQuote(state, quote) {
        state.selectedQuote = quote;
    },
    resetSelectedQuote(state) {
        for (const key in state.selectedQuote) {
            if (key in state.rules_quotes) {
                state.selectedQuote[key] = state.rules_quotes[key].default_value == "null" ? null : state.rules_quotes[key].default_value;
            }
        }
    },
    resetQuotes(state) {
        state.page = {};
        state.form = {};
        state.quotes = [];
        state.selectedQuote = {
            quote_id: null,
            company_id: "",
            quote_date: "",
            reference_number: "",
            status_id: "",
            billing_address_id: "",
            shipping_address_id: "",
            comments: "",
            quote_details: [],
        };
        state.quotes_filter = {
            search: "",
            status_id: "",
            page_size: 2,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
